import React from 'react';
import { isLargeBundle, LARGE_BUNDLE_NOTE } from '../constants/downloadLimits';

// One line under the bundle size when the zip is big enough that a slow
// connection may not finish it within the server's one-hour window.
export default function LargeBundleNote({ totalMb }) {
  if (!isLargeBundle(totalMb)) return null;
  return <p className="small text-muted mb-0 mt-1" role="note">{LARGE_BUNDLE_NOTE}</p>;
}
